<template>
  <div class="container">
    <div class="live-run">
      <slot></slot>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'container-live-run'
}
</script>



// WEBPACK FOOTER //
// Container.vue?312bb9e3